import React from 'react';
import { View } from 'react-native';
import { Text } from '@ui-kitten/components';

import ScreenWrapper from '../../Components/ScreenWrapperWithTitleAnimation';

import styles from './styles';

class ChoosePlan extends React.Component {
  render() {
    return (
      <ScreenWrapper title="Choose Plan">
        <View style={styles.wrapper}>
          <Text>Choose Plan Screen</Text>
        </View>
      </ScreenWrapper>
    );
  }
}

export default ChoosePlan;
